<template>
    <div class="mainbody">
        <el-container>
            <el-header class="frame-header">
                <el-row type="flex"  justify="center" align="middle">
                    <el-col :span="12">
                            <table class="logo">
                                <tr>
                                    <td>
                                        <img id="logoImg" style="height:2.7rem; max-width: 100%; max-height: 60%;-webkit-filter: grayscale(100%);" alt="logo" src="../../assets/images/logo.png" />
                                    </td>
                                    <td style="padding-left: 5px;">
                                        <div style="font-size: 1.3rem;letter-spacing: 2.5px;">自助打印终端</div>
                                        <div style="font-size: 0.7rem;margin-top: 5px;letter-spacing: 3px;margin-left: 2px;">SELF-SERVICE TERMINALS</div>
                                    </td>
                                </tr>
                            </table>
                    </el-col>
                    <el-col :span="12"></el-col>
                </el-row>
            </el-header>
            <el-main class="frame-main">
                <router-view>
                </router-view>
            </el-main>
            <el-footer class="frame-footer">
                <el-row>
                    <el-col :span="8">               
                    </el-col>
                    <el-col :span="8">
                        <table style="color:rgb(134, 137, 139);font-size: 0.7rem;height: 100%;width: 100%;text-align:center;letter-spacing:1px;">
                            <tr></tr>
                            <tr>
                                <td>由{{company}}提供技术支持</td>
                            </tr>
                            <tr>
                                <td><strong>设备编号：{{deviceNo}}</strong></td>
                            </tr>
                            <tr></tr>
                        </table>
                    </el-col>
                    <el-col :span="8"></el-col>
                </el-row>
            </el-footer>
        </el-container>
    </div>
</template>

<script>

export default {
    name: "managerMain",
    data() {
        return {
            company:"北京第玖元素科技有限公司",
            deviceNo:"001",
            managerUrl: this.myStore.state.manageUrl,
            mainUrl:this.myStore.state.mainUrl
        }
    },
    created() {
        this.myStore.setIsManageUrlAction(true);
        let url = this.managerUrl + '/inputName';
        if (this.$route.path !== url) {
            this.$router.push(url);
        }
        let deviceNo = this.myStore.state.deviceNo;
         if(typeof(deviceNo) !== "undefined") {
             this.deviceNo = deviceNo;
         }
    },
    destroyed () {
        this.myStore.clearIsManageUrlAction();;
    },
}
</script>

<style scoped>
    .mainbody,.el-container.is-vertical{
        height: 100%;
    }
    .frame-header{
        background: linear-gradient(rgba(81, 152, 521, 1) 50%, rgba(71, 144, 255, 1) 50%);
        border-bottom: 2px solid #577899;
        height: 9% !important;
        text-align: left;
    }
    .frame-footer {
        background-color: white;
        height: 7% !important;
    }
    .frame-main {
        background-color: #f5f5f5;
        background-size: 100% 100%;
        background-position: center;
        background-attachment: fixed;
        height: 84%;
    }
    .el-row,.el-col,.logo{
        height: 100%;
    }
    .el-col{
        display:flex;
    }
    .logo {
        left: 2rem;
        color: #fff;
    }
    .timeout {
        right: 2rem;
        color: #fff;
    }
    .hbt {
        font-size: 3rem;
        padding: 0;
    }
    
</style>